export default __webpack_public_path__ + "static/media/NVC_Equipo_LOGO.c7cdf3c9.png";